import React from "react";
import { Quote } from "lucide-react";

const quotes = [
  {
    text:
      "We inherited Mom's house across town and had no idea what to do. Cash 4 Properties made it painless — 9 days from first call to check in hand.",
    name: "The Rodriguez Family",
    place: "Kinston, NC",
    img: "https://images.pexels.com/photos/8841502/pexels-photo-8841502.jpeg",
  },
  {
    text:
      "The house needed a new roof, foundation work, the whole thing. Every realtor passed. These guys bought it as-is and we moved on with our lives.",
    name: "Marcus & Lena Hall",
    place: "Greenville, NC",
    img: "https://images.pexels.com/photos/7281954/pexels-photo-7281954.jpeg",
  },
  {
    text:
      "Honest, fast, fair. They explained every number. No surprises at closing. I would recommend them to anyone in a tough spot.",
    name: "Denise W.",
    place: "New Bern, NC",
    img: "https://images.pexels.com/photos/7578991/pexels-photo-7578991.jpeg",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials"
      className="border-b border-[var(--c4p-line)] bg-[var(--c4p-forest)] py-20 text-[var(--c4p-ivory)] lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex items-end justify-between gap-8">
          <div>
            <span className="eyebrow !text-[var(--c4p-amber)]">
              Real sellers. Real results.
            </span>
            <h2 className="font-display mt-4 text-[40px] leading-[1.02] sm:text-[52px] lg:text-[60px]">
              Eastern NC families,{" "}
              <span className="font-display-italic text-[var(--c4p-amber)]">served with respect.</span>
            </h2>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {quotes.map((q, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative rounded-2xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur"
            >
              <Quote
                size={26}
                className="absolute right-6 top-6 text-[var(--c4p-orange)]/70"
              />
              <blockquote className="font-sans-ui text-[16px] leading-relaxed text-[var(--c4p-ivory)]/95">
                "{q.text}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-5">
                <img
                  src={q.img}
                  alt={q.name}
                  className="h-12 w-12 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="font-sans-ui text-[15px] font-bold">{q.name}</div>
                  <div className="font-sans-ui text-[12.5px] text-[var(--c4p-amber)]">
                    {q.place}
                  </div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
